import { render, staticRenderFns } from "./top-filter-2.vue?vue&type=template&id=167150ae"
import script from "./top-filter-2.vue?vue&type=script&lang=js"
export * from "./top-filter-2.vue?vue&type=script&lang=js"
import style0 from "./top-filter-2.vue?vue&type=style&index=0&id=167150ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports